export const classifyRating = (rating: number | null | undefined): string => {
  if (rating == null) {
    return 'no-rating'
  } else if (rating >= 4.0) {
    return 'good-rating'
  } else if (rating >= 3.1) {
    return 'medium-rating'
  } else {
    return 'poor-rating'
  }
}
